import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import PosthogPlugin from './plugins/posthog';
import * as Sentry from "@sentry/vue";
import router from './router';
import './index.css';
import {
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from "@/firebase";
import { useMainStore } from '@/store';
import VueGtag from "vue-gtag";

const app = createApp(App);
const pinia = createPinia();

app.config.globalProperties.$auth = auth; // Add auth to global variable

app.use(PosthogPlugin);
app.use(pinia);
app.use(router);
app.use(VueGtag, {
  config: { id: "G-4SRF6EGG86" }
})

Sentry.init({
  app,
  dsn: "https://9798a677677c5b4c53a36649f8d25973@o1156604.ingest.us.sentry.io/4508581423677440",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const store = useMainStore();
onAuthStateChanged(auth, (user) => {
  if (user) {
    store.setUser(user);
  } else {
    store.clearUser();
  }
});

app.mount('#app');
